import { colors } from '@opallabs/spectrum'

const postWidth = {
  desktopSingle: 900,
  mobileSingle: 375,
}

const postHeight = {
  desktopSingle: 563,
  mobileSingle: 667,
}

const lapidaryVideo = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
}

const assetStyles = {
  desktopSingle: {
    height: postHeight.desktopSingle,
    width: '393px',
    margin: '0 auto',
    overflow: 'hidden',
    '.lapidary-video': {
      ...lapidaryVideo,
    },
  },
  mobileSingle: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    overflow: 'hidden',
    '.lapidary-video': {
      ...lapidaryVideo,
    },
  },
}

const renderDisplayLayout = {
  desktopSingle: {
    width: postWidth.desktopSingle,
    height: postHeight.desktopSingle,
    flexDirection: 'row',
  },
  mobileSingle: {
    height: postHeight.mobileSingle,
    width: postWidth.mobileSingle,
    flexDirection: 'column',
    position: 'relative',
  },
}

const baseStyles = ({ display, hasAsset }) => ({
  backgroundColor: '#d0dae1',
  borderRadius: 2,
  display: 'flex',
  fontFamily: 'Helvetica',
  ...renderDisplayLayout[display],
  '.kuiper-asset-base': {
    display: 'flex',
    ...assetStyles[display],
    '&.kuiper-placeholder': {
      backgroundColor: colors.n8.base,
    },
    '.kuiper-asset': {
      backgroundColor: hasAsset ? 'black' : '#D0DAE1',
    },
  },
})

export { baseStyles }
